export const theme = {
  colors: {
    green: "#34C759",
    green_2: "#C2EFCE",
    green_3: "#D6F4DE",
    green_4: "#6FAFA7",
    purple: "#7B5EED",
    purple_hover: "#5631E8",
    purple_2: "#ECE8FC",
    purple_3: "#B7A8F3",
    purple_4: "#fafaff",
    purple_5: "#F7F6FEB2",
    purple_6: "#8D4D80",
    purple_7: "#B58FB3",
    purple_8: "#7355EC",
    purple_9: "#E3DDFB",
    purple_10: "#F1EEFD",
    grey_1: "#4A4A4F",
    grey_2: "#74747B",
    grey_3: "#A0A1A6",
    grey_4: "#C5C6C9",
    grey_5: "#DFE0E1",
    grey_6: "#F8F8F8",
    grey_7: "#F7F7F7",
    grey_8: "#DCDDEE",
    grey_9: "#e0e0e0",
    grey_10: "#4b4b4b",
    black: "#0E0E0E",
    white: "#ffffff",
    page_background: "#f8f8f8",
    red_1: "#EB0C00",
    red_2: "#FFC5C2",
    red_3: "#E75A7C",
    red_4: "#E38EA8",
    yellow_1: "#FFCC00",
    yellow_2: "#FFF0B2",
    yellow_3: "#F9F1D1",
    yellow_4: "#E69F43",
    orange_1: "#A86810",
    orange_2: "#DDB378",
    trasparent: "transparent",
    blue_1: "#4F7892",
    blue_2: "#6395BC",
  },
  variables: {
    sidebar_big_width: "280px",
    sidebar_small_width: "65%",
    sidebar_hide_width: "84px",
    sidebar_padding: "21px",
    modal_padding: "24px",
    border_radius_1: "8px",
    border_radius_2: "12px",
    border_radius_3: "16px",
    border_radius_4: "20px",
    border_radius_5: "4px",
    border_radius_6: "6px",
    tab_menu_width: "80px",
    height_1: "32px",
    height_2: "40px",
    height_3: "48px",
    height_4: "50px",
    height_5: "18px",
    height_6: "24px",
    height_7: "16px",
    height_8: "20px",
    height_9: "16px",
    height_10: "28px",
    modal_box_shadow: "0px 2px 8px 0px rgba(68, 68, 79, 0.08)",
    side_panel_box_shadow: "0px 2px 8px 0px #4A4A4F33",
    fw_semiBold: "600",
    fw_medium: "500",
    fw_Regular: "400",
    fs_40: "40px",
    fs_28: "28px",
    fs_26: "26px",
    fs_24: "24px",
    fs_22: "22px",
    fs_18: "18px",
    fs_16: "16px",
    fs_14: "14px",
    fs_12: "12px",
    fs_10: "10px",
    fs_8: "8px",
    user_panel_width: "265px",
    filter_panel_width: "350px",
    sw_1: "1px",
    sw_2: "1.5px",
    sw_3: "1.8px",
    sw_4: "2px",
    // eslint-disable-next-line quotes
    font_family: '"Work Sans", sans-serif',
    table_icon_cell_width: 26,
    table_avatar_cell_width: 28,
    table_surname_cell_width: 130,
    table_name_cell_width: 160,
  },
  breakpoints: {
    SM: 640,
    MD: 768,
    LG: 1024,
    XL: 1280,
    XXL: 1536,
  },
};
